import React, {Component} from 'react';
import Header from './Dashboard/Header';
import "../style/hamburgerMenu.css";
import "../style/mainDashboard.css";
import MainContext from '../contexts/ContextProvider';
import HamburgerMenu from './Dashboard/HamburgerMenu';
import MainPage from './Dashboard/MainPage';

class MainDashboard extends Component {
    state = {
        activeMenu: window.innerWidth < 1024,
        widthWindow: 0,
    }

    sidebarWidth = () => {
        const w = window.innerWidth;
        if (this.state.activeMenu) return "0";
        if (w <= 426) return "82%";
        if (w <= 768) return "48%";
        if (w <= 1024) return "28%";
        return "var(--sidebar-w, 280px)";
    };

    contentWidth = () => {
        const w = window.innerWidth;
        if (w <= 768) return "100%";
        if (this.state.activeMenu) return "100%";
        if (w <= 1024) return "72%";
        return "calc(100% - var(--sidebar-w, 280px))";
    };

    render() {
        const menuOpen = !this.state.activeMenu;
        const showOverlay = menuOpen && window.innerWidth <= 768;

        return (
            <MainContext.Provider value={{activeMenu: this.state.activeMenu, handleSidebar: this.handleSidebar}}>
                <div className={`main-container${menuOpen ? ' sidebar-open' : ' sidebar-collapsed'}`}>
                    {showOverlay ? (
                        <button
                            type="button"
                            className="sidebar-backdrop"
                            aria-label="بستن منو"
                            onClick={this.handleSidebar}
                        />
                    ) : null}
                    <div className="sidenav" style={{width: this.sidebarWidth()}}>
                        <HamburgerMenu/>
                    </div>
                    <div className="main-page-container" style={{
                        zIndex: window.innerWidth <= 768 ? 1 : undefined,
                        width: this.contentWidth(),
                    }}>
                        <Header/>
                        <div className="page-canvas">
                            <MainPage/>
                        </div>
                    </div>
                </div>
            </MainContext.Provider>
        );
    }

    handleSidebar = () => {
        this.setState({activeMenu: !this.state.activeMenu})
    }
}

export default MainDashboard;
